import { Component, OnInit, OnChanges, SimpleChanges } from '@angular/core';
import { Input, Output, EventEmitter } from '@angular/core';
import { PreferencesService } from '../../../core/services/preferences.service';
import { TranslateService } from '@ngx-translate/core';
import * as _ from 'lodash';

const SYS_ORDER_DISABLED = 'SYS_ORDER_DISABLED';

@Component({
    selector: 'app-table-config',
    templateUrl: './table-config.component.html',
    styleUrls: ['./table-config.component.css']
})
export class TableConfigComponent implements OnInit, OnChanges {

    @Input('list') list: Array<any> = [];
    @Output('onsave') onsave: EventEmitter<any> = new EventEmitter<any>();
    defaultList = [];
    validation = [];
    allChecked = false;

    constructor(
        private translate: TranslateService,
        private preferences: PreferencesService
    ) { }

    ngOnInit() {
    }

    ngOnChanges(changes: SimpleChanges) {
        if (changes['list'] && changes['list'].currentValue) {
            const val = changes['list'].currentValue;
            this.defaultList = !val ? [] : val.map(x => _.cloneDeep(x));
            this.validate();
            this.allChecked = !this.defaultList.some(item => !item.selected);
        }
    }


    allCheckedChange() {
        this.defaultList.forEach(item => {
            item.selected = this.allChecked;
        });
    }

    handleList(modal, type) {
        modal.show();
        modal.type = type || '';
        modal.title = this.translate.instant('common.setup-column');
    }

    // 排序
    sort(index, type) {
        const line = this.defaultList[index];
        if (!line || line.selected !== true) return;
        if (type === 'up') {
            if (index === 0) return;
            this.swapValue(this.defaultList[index - 1], line, 'sort');
        } else {
            if (index === this.defaultList.length - 1) return;
            this.swapValue(this.defaultList[index + 1], line, 'sort');
        }
        this.defaultList.sort((v1, v2) => {
            return v1.sort - v2.sort;
        });
    }

    swapValue(o1, o2, key) {
        const tmp = o2[key];
        o2[key] = o1[key];
        o1[key] = tmp;
    }

    // 保存配置
    saveConfig(modal) {
        if (!_.every(this.validation, x => !Object.keys(x).length)) return;
        this.preferences.set('colConfig', this.defaultList, false);
        this.onsave.emit(this.defaultList);
        modal.hide();
    }

    validate() {
        this.validation = this.defaultList.map(x => this.validateRow(x));
    }

    validateRow(row) {
        const res = {};
        if (!row.selected) return res;
        const isNum = /^[1-9][0-9]*$/;
        if (!isNum.test(row.width + '')) {
            res['width'] = '列宽请填入1-300整数，必填';
        } else {
            const width = parseInt(row.width + '', null);
            if (width < 1 || width > 300) {
                res['width'] = '列宽请填入1-300整数，必填';
            }
        }
        if (row.orderField && row.orderField.length) {
            if (row.orderField !== SYS_ORDER_DISABLED && !isNum.test(row.orderField + '')) {
                res['orderField'] = '排列顺序请填入正整数,可不填';
            }
        }
        return res;
    }

    hasErrorInput(index, key) {
        if (index < this.validation.length) {
            const msg = this.validation[index][key];
            return !!msg;
        }
        return false;
    }

    onChange(i) {
        if (!this.validation.length) {
            this.validate();
        } else {
            this.validation[i] = this.validateRow(this.defaultList[i]);
        }
        this.allChecked = !this.defaultList.some(item => !item.selected);
    }

}



// WEBPACK FOOTER //
// F:/WMS/X-xiamenzhuhe-SDM234/zhuhe-234/sdm_fe/src/app/shared/components/table-config/table-config.component.ts